import { render } from "./SurveyAfterPurchase.vue?vue&type=template&id=18d4c9ce&scoped=true"
import script from "./SurveyAfterPurchase.vue?vue&type=script&lang=js"
export * from "./SurveyAfterPurchase.vue?vue&type=script&lang=js"

import "./SurveyAfterPurchase.vue?vue&type=style&index=0&id=18d4c9ce&scoped=true&lang=scss"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18d4c9ce"],['__file',"src/views/post/SurveyAfterPurchase.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "18d4c9ce"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('18d4c9ce', __exports__)) {
    console.log('reload')
    api.reload('18d4c9ce', __exports__)
  }
  
  module.hot.accept("./SurveyAfterPurchase.vue?vue&type=template&id=18d4c9ce&scoped=true", () => {
    console.log('re-render')
    api.rerender('18d4c9ce', render)
  })

}


export default __exports__